<div class="wrapper"   *ngIf="!(isLoading$|async)">
    <ng-container *ngIf="(labels$|async)?.length else noLabels">
        <app-label *ngFor="let label of labels$|async"
            [color]="label.colour"
            (unassignLabel)="unassignLabel(label)"
            [text]="label.name"></app-label>
    </ng-container>
    <ng-template #noLabels>
        <div (click)="showAddLabelsModal()"
            class="add-labels-cta">Add Labels</div>
    </ng-template>
    <div class="add-label"
        (click)="showAddLabelsModal()">+</div>
</div>
<div class="loading-wrapper"
    *ngIf="isLoading$|async">
    <mat-spinner [diameter]="25"></mat-spinner>
</div>